<script>
import { getIndex, setLocation, generateUUID, points, CHART_COLORS, transparentize } from "@/utils";
import {Chart} from 'chart.js'
import AnnotationPlugin from 'chartjs-plugin-annotation';

Chart.plugins.register(AnnotationPlugin)

const footer = (tooltipItems) => {
  let sum = 0;

  tooltipItems.forEach(function(tooltipItem) {
    sum += tooltipItem.parsed.y;
  });
  return 'Sum: ' + sum;
};

// Chart.controllers.quadrants = custom;
const quadrants = {
  id:'quadrants',
  beforeDraw(chart, args, options) {
    const {
      ctx,
      chartArea: { left, top, right, bottom },
      scales,
    } = chart;

    const midX = scales['x-axis-1'].getPixelForValue(0);
    const midY = scales['y-axis-1'].getPixelForValue(0);

    ctx.save();
    ctx.fillStyle = options.topLeft;
    ctx.fillRect(left, top, midX - left, midY - top);
    ctx.fillStyle = options.topRight;
    ctx.fillRect(midX, top, right - midX, midY - top);
    ctx.fillStyle = options.bottomRight;
    ctx.fillRect(midX, midY, right - midX, bottom - midY);
    ctx.fillStyle = options.bottomLeft;
    ctx.fillRect(left, midY, midX - left, bottom - midY);
    ctx.restore();
  }
};
var highestX = 0
var highestY = 0

// Chart.controllers.quadrants = custom;

export default {
  name: "quadrant-chart",
  props: [
    "quadrantData"
  ],
  data(){
    return {
      dataFromBasket: [],
      cData: {
        labels: [],
        datasets: [
          {
            label: 'Scatter Dataset',
            fill: false,
            borderColor: '#f87979',
            backgroundColor: '#f87979',
            data: [
              { x: 7, y: 10 },
              { x: 10, y:10 },
            ],
          },
          {
            label: 'Scatter Dataset 2',
           data: [
              { x: 1, y: 5 },
              { x: 3, y: 6 },
            ],
            borderColor: CHART_COLORS.blue,
            backgroundColor: transparentize(CHART_COLORS.blue, 0.5),
          }
        ]
      },
      cOptions: {},
      plugin: quadrants,
      defaultLegendClickHandler: {},
      chartIntance: {},
      allItemsLabelList: [],
      selectedItemsLabelList:[],
      datasetsBackup: [],
      selectAllChkbxText: 'De-select All',
      searchCatType: null
    }
  },
  mounted(){
    // this.defaultLegendClickHandler = Chart.defaults.global.legend.onClick;
    this.dataParser(this.quadrantData)
  },
  watch:{
    "quadrantData"(value){
      this.dataParser(value)
    },
    "selectedItemsLabelList"(){
      let quadrantDataSet = [...this.datasetsBackup]
      let selectedLabel = [...this.selectedItemsLabelList]
      selectedLabel.sort() // sort the label list
      this.updateQuadrantFromChkbox(selectedLabel, quadrantDataSet)
    }
  },
  computed:{
    likesAll() {
      return this.selectedItemsLabelList.length === this.allItemsLabelList.length;
    },
    likesSome() {
      return this.selectedItemsLabelList.length > 0 && !this.likesAll;
    },
    iconChk(){
      if (this.likesAll) return "mdi-close-box";
      if (this.likesSome) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
    compItemsLabelList(){
      let itemsfiltered =  this.allItemsLabelList.filter(item => {
            if(!this.searchCatType) return this.allItemsLabelList;
            return (item.label.toLowerCase().includes(this.searchCatType.toLowerCase()) );
      })

      return itemsfiltered
    }

  },
  methods: {
    refretshQuadrant(){
      setTimeout(() => {
        let quadrantDataSet = [...this.datasetsBackup]
        let selectedLabel = [...this.selectedItemsLabelList]
        selectedLabel.sort() // sort the label list
        this.updateQuadrantFromChkbox(selectedLabel, quadrantDataSet)
      }, 1000);
    },
    clearSearch () {
      this.searchCatType=null;
    },
    updateQuadrantFromChkbox(labels, datasets){
      let selectedLabel = labels
      let quadrantDataSet = datasets

      let sortedQuadrantDataSets = quadrantDataSet.filter((obj) => { // to sort the collection base on basketType above (sort())
        return selectedLabel.indexOf(obj.label) >= 0;
      });
      sortedQuadrantDataSets = selectedLabel.map(x => sortedQuadrantDataSets[sortedQuadrantDataSets.findIndex(o => o.label === x)])
      sortedQuadrantDataSets = sortedQuadrantDataSets.filter(obj => obj != undefined)

      //reset the data in quadrant using these sets
      this.cData.labels = selectedLabel 
      this.cData.datasets = sortedQuadrantDataSets

      this.$nextTick(() => {
        this.chartIntance.update();
      })
    },
     toggleGraphLocation() {
      this.$nextTick(() => {
        if (this.likesAll) {
          this.selectedItemsLabelList = [];
          this.selectAllChkbxText = "Select All"
        } else {
          let data = [];
          for (let i = 0; i < this.allItemsLabelList.length; i++) {
            let item = this.allItemsLabelList[i];
            data.push(item.label);
          }
          data.sort()
          this.selectedItemsLabelList = data;
          let datasets = [...this.datasetsBackup]
          this.updateQuadrantFromChkbox(data, datasets)
          this.selectAllChkbxText = "De-select All"
        }
      });
    },
    cOptionreturn(){
      return {
        legend: {
            display: false,
            position: 'top',
            // onClick: this.newLegendClickHandler(event, elem)
            // onClick: function (event, elem) {
            // onClick: (event, elem) => {
            //   this.newLegendClickHandler(event, elem)
            // }
        },
        // tooltips: {
        //     mode: 'index',
        //     intersect: false
        // },
        title: {
          display: false,
          text: 'Menu item categories'
        },
        tooltips: {
            // enabled: true,
            // intersect: false,
            mode: 'point', // index,nearest,average
            callbacks: {
              // footer: footer,
              title: function(context,data) {
                var label = data.labels[context[0].datasetIndex];
                return "Item"
              },

              label: function(context,data) {
                // console.log('--- labels: ',this.cData.labels)
                
                let filtered = data.datasets.filter(
                  item => item.label === data.labels[context.datasetIndex]
                );
                let filtered2 = filtered[0].data.filter(
                  item => item.x === context.xLabel
                );
                
                var label = data.labels[context.datasetIndex];
                var description = filtered2[0]['description']
                var quadrantName = '' 
   
                if(context.xLabel >= (highestX/2) && context.yLabel >= (highestY/2) ){
                  quadrantName = 'Winners' 
                }else if(context.xLabel <= (highestX/2) && context.yLabel <= (highestY/2) ){
                  quadrantName = 'Underperformers' 
                }else if(context.xLabel > (highestX/2) && context.yLabel <= (highestY/2) ){
                  quadrantName = 'One Hit Wonders' 
                }else if(context.xLabel < (highestX/2) && context.yLabel > (highestY/2) ){
                  quadrantName = 'Hidden Gems' 
                }

                return description + ', ' +label + ', ' + quadrantName + ', [Item volume]: ' + context.xLabel + ' [Reorder Rate]: ' + context.yLabel.toFixed(2)+ '%' ;
              },
              labelTextColor: function(tooltipItem, chart) {
                return 'white';
              },
              titleFontStyle: 'bold',
              footerFontStyle: 'bold',
              bodyFontStyle:'bold',
              titleFontSize: 24,
              textDirection: 'rtl'
            }
          },
        responsive: true,
        showTooltips: true,
        scales: {
          xAxes: [
            { 
              // type:'logarithmic',
              display: true,
              scaleLabel: {
                display: true,
                labelString: 'Item volume',
              },
              ticks: {
                beginAtZero: true,
                steps: 10,
                stepValue: 1,
                max:  11001,
              },
            },
          ],
          yAxes: [
              {
                // type:'logarithmic',
                display: true,
                scaleLabel: {
                  display: true,
                  labelString: 'Re-order rate',
                },
                ticks: {
                  beginAtZero: true,
                  steps: 10,
                  stepValue: 1,
                  max: 100,
                },
              },
            ],
        },
        plugins: {
          quadrants: {
            topLeft: 'white',
            bottomRight: 'white',
            topRight: 'white',
            bottomLeft: 'white',
          },
        },
        annotation: {
          drawTime: 'afterDatasetsDraw',
          annotations: [
            {
              type: 'line',
              mode: 'horizontal',
              scaleID: 'y-axis-1',
              value: 50,
              borderColor: 'black',
              borderWidth: 1,
            },
            {
              drawTime: 'afterDraw',
              type: 'line',
              mode: 'vertical',
              scaleID: 'x-axis-1',
              value: 5000,
              borderColor: 'black',
              borderWidth: 1,
            },
          ],
        },
      }
    },
    newLegendClickHandler(e, legendItem){
      // var index = legendItem.datasetIndex;
      var index = legendItem.datasetIndex;
        if (index > 1) {
            // Do the original logic
            this.defaultLegendClickHandler(e, legendItem);
            console.log('---a',e)
            console.log('---a',legendItem)
        } else {
            console.log('---b')
            let ci = this.chartIntance;
            [
                ci.getDatasetMeta(0),
                ci.getDatasetMeta(1)
            ].forEach(function(meta) {
                meta.hidden = meta.hidden === null ? !ci.data.datasets[index].hidden : null;
            });
            console.log('---', ci)
            ci.update();
        }

    },
    async dataParser(dataArray){

      let newCollection = await this.grouByKey(dataArray, 'basketType')
      let perBasketTypeData = []
      let quadrantDataSets = []
      let basketType = Object.keys(newCollection)
      var forCheckboxWithColor = []


      try {
        Object.keys(newCollection).forEach((item) => {
          perBasketTypeData['description'] = newCollection[item]['description']
          perBasketTypeData[item] = newCollection[item].map(sublist => { // create new list segregated by basketpe with all x and y data
            return { 
              x: ( !sublist.total_orders || sublist.total_orders != undefined) ? sublist.total_orders : 0,
              y: ( !sublist.reorder_rate || sublist.reorder_rate != undefined) ? (sublist.reorder_rate *100) : 0,
              description: sublist.description
            } 
          })
        });
        let checkboxIncre = 0
        basketType.forEach((basketTypeName) => {
          let color = this.getRandomColor()
          let perItem = {
            label: basketTypeName,
            fill: false,
            borderColor: color,
            backgroundColor: color,
            data: perBasketTypeData[basketTypeName]
          }

          let forCheckbox = {
            index: checkboxIncre,
            label: basketTypeName,
            backgroundColor: color
          }
          checkboxIncre++
          forCheckboxWithColor.push(forCheckbox)
          quadrantDataSets.push(perItem) // manually push item to recreate the expected version
        });
      
      } catch (error) {
        console.log('--ERROR in quadrant parser: ',error)
      }

      basketType.sort() // sort the label list

      let sortedQuadrantDataSets = quadrantDataSets.filter((obj) => { // to sort the collection base on basketType above (sort())
        return basketType.indexOf(obj.label) >= 0;
      });
      sortedQuadrantDataSets = basketType.map(x => sortedQuadrantDataSets[sortedQuadrantDataSets.findIndex(o => o.label === x)])
      sortedQuadrantDataSets = sortedQuadrantDataSets.filter(obj => obj != undefined)

      this.cData.labels = basketType // this will place all the label to be accesible in tooltip
      this.datasetsBackup = sortedQuadrantDataSets
      this.cData.datasets = sortedQuadrantDataSets

      //populate checkbox
      this.selectedItemsLabelList = basketType // to make it selected all (kunwari)
      this.generateChkBoxQuadrant(forCheckboxWithColor)

      highestX = this.getClosestDivisibility( Math.ceil(this.getHighestValue(quadrantDataSets,'x')) )
      highestY = Math.ceil(this.getHighestValue(quadrantDataSets,'y'))
      this.cOptions = this.cOptionreturn()
      this.cOptions.scales.xAxes[0].ticks.max = (highestX)
      this.cOptions.scales.yAxes[0].ticks.max = (highestY)

      this.cOptions.annotation.annotations[1].value = (highestX/2)
      this.cOptions.annotation.annotations[0].value = (highestY/2)

      this.$nextTick(() => {
        this.loadChart();
        // this.chartIntance.canvas.parentNode.style.width = '80%';
        this.chartIntance.canvas.parentNode.style.marginRight = '200px';
      })

      // this.dataFromBasket = value
    },
    getClosestDivisibility(value){
      if( (value/10000) > 1 ){ // closest highest divisible by 10k
        return Math.ceil(value / 10000) * 10000;
      }else if ( (value/1000) > 1 ){// closest highest divisible by 1k
        return Math.ceil(value / 1000) * 1000;
      }else{
        return Math.ceil(value / 100) * 100;
      }
    },
    generateChkBoxQuadrant(item){
      this.allItemsLabelList = item.sort((a, b) => a.label.localeCompare(b.label)); // sort it base label key
    },
    getHighestValue(data, keyTarget){
      let keyName = keyTarget
      var sum = 0
      var count = 0
      var mean = 0
      var variance = 0

      data.forEach((dataset) => {
        dataset.data.forEach((point) => {
          count++
          sum += point[keyName]
          // if (point[keyName] > maxX) {
          //   maxX = point[keyName];
          // }
        });
      });
      mean = (sum/count)
      sum = 0
      data.forEach((dataset) => {
        dataset.data.forEach((point) => {
          sum += ((point[keyName] - mean) ** 2)
        });
      });
      
      variance = sum/count
      return mean + Math.sqrt(variance);
    },
    async grouByKey(array, key){
      return array.reduce((result, currentValue) => {
        // If an array already present for key, push it to the array. Else create an array and push the object
        (result[currentValue[key]] = result[currentValue[key]] || []).push(
          currentValue
        );
        // Return the current iteration `result` value, this will be taken as next iteration `result` value and accumulate
        return result;
      }, {}); // empty object is the initial value for result object
    },
    getRandomColor() {
      var letters = '0123456789ABCDEF';
      var color = '#';
      for (var i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    },
    loadChart(){
      const ctx = document.getElementById('myChart');
      const chart = new Chart(ctx,{
        type: 'scatter',
        data: this.cData,
        options: this.cOptions,
        plugins:[this.plugin]
      });
      this.chartIntance = chart
    }
  }
};
</script>

<template>
  <div class="main-con" style="text-align: center;margin: auto;">
    <div class="quandrant-con" style=" center;margin: auto;">
      <canvas id='myChart' ref='myChart'></canvas>
    </div>
    <div class="check-box-graph">
      <div class="align-items-center" style="
          text-align: center;
          font-weight: 600;
      ">Category Type</div>
      <hr>
      <v-text-field class="mx-3" flat label="Search" prepend-inner-icon="search" v-model="searchCatType" clearable @click:clear="clearSearch"></v-text-field>
      
      <v-list multiple='multiple'>
        <v-list-item ripple @click="toggleGraphLocation">
          <v-list-item-action>
            <v-icon
              :color="selectedItemsLabelList.length > 0 ? 'indigo darken-4' : ''"
            >
              {{ iconChk }}
            </v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              {{selectAllChkbxText}}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>                    
        <v-checkbox v-for="(item, index) in compItemsLabelList"
          :key="item.index" 
          v-model="selectedItemsLabelList" 
          :value="item.label"
          >
          <template v-slot:label>
            <div class="colorBar" :style="{ backgroundColor: item.backgroundColor }"></div>
            <div v-html="item.label"></div>
          </template>
        </v-checkbox>                      
      </v-list>                  
    </div>
  </div>
</template>


<style>

.check-box-graph .v-messages.theme--light.primary--text,
.check-box-graph .v-messages.theme--light {
  display: none !important;
}
.check-box-graph .v-input.v-input--is-label-active.v-input--is-dirty.theme--light.v-input--selection-controls.v-input--checkbox.primary--text,
.check-box-graph .v-input.theme--light.v-input--selection-controls.v-input--checkbox{
  margin-top: 0px;
}
.check-box-graph label.v-label.theme--light,
.check-box-graph .v-input__slot {
  margin-bottom: 0px !important;
}
.check-box-graph{
  overflow: auto;
  height: 75%;
  width: 95%;
  padding: 10px 12px;
  margin-bottom: 10px;
  border: 1px solid #00000059;
  border-radius: 10px;
}
.check-box-graph label.v-label.theme--light {
  font-size: 14px;
}

.main-con .check-box-graph{
  display: inline;
  position: absolute;
  width: 200px;
  top: 85px;
  right: 20px;
}
.main-con .colorBar{
  width: 15px;
  height: 15px;
  margin-right: 5px;
  border-radius: 25px;
}

.main-con . .colorBar{

}
</style>
